(function () {
  // Custom button+panel accordion (not native <details>/<summary>) so
  // open/close gets a smooth height transition instead of the browser's
  // instant snap. JS measures each answer's natural height (its
  // scrollHeight, which reports the full unclipped content height
  // regardless of the wrap's own height:0 default) and sets an exact
  // pixel height to transition to/from.
  document.querySelectorAll(".faq-item__question").forEach((button) => {
    const item = button.closest(".faq-item");
    const wrap = item.querySelector(".faq-item__answer-wrap");

    button.addEventListener("click", () => {
      const isOpen = button.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        button.setAttribute("aria-expanded", "false");
        item.classList.remove("is-open");
        wrap.style.height = "0px";
      } else {
        button.setAttribute("aria-expanded", "true");
        item.classList.add("is-open");
        // Measure with height temporarily freed so scrollHeight reflects
        // the answer's true natural size, not whatever it was clipped to.
        wrap.style.height = "auto";
        const target = wrap.scrollHeight;
        wrap.style.height = "0px";
        // Force a reflow so the browser commits the "0px" frame before the
        // next line changes it again — without this, some browsers collapse
        // both synchronous writes into one and skip the transition
        // entirely, jumping straight to the end state.
        void wrap.offsetHeight;
        wrap.style.height = `${target}px`;
      }
    });
  });
})();
